<template>
  <EditItemForm :con="con" :editedItem="editedItem" @closed="close">
    <template v-slot:dialog-text="{ item }">
      <v-container>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="item.name"
              :label="$t('crudRooms.fieldName')"
              :rules="rules.inputTextRequired"
              required
              color="grey"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="item.reference"
              :label="$t('crudRooms.fieldReference')"
              :rules="rules.inputText"
              color="grey"
            />
          </v-col>
          <v-col cols="4">
            <v-switch
              v-model="item.available"
              :label="$t('crudRooms.fieldAvailable')"
              color="red"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="item.fullCapacity"
              :label="$t('crudRooms.fieldFullCapacity')"
              :rules="rules.inputNumber"
              color="grey"
              :suffix="$t('crudRooms.fieldFullCapacitySuffix')"
              @input="updatePartialCapacity"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="item.reducedCapacity"
              :label="$t('crudRooms.fieldPartialCapacity')"
              color="grey"
              :hint="$t('crudRooms.fieldPartialCapacityHint')"
              persistent-hint
              disabled
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </EditItemForm>
</template>

<script>
import EditItemForm from "../EditItemForm";
import rules from "@/models/InputRules";

export default {
  name: "EditRoomForm",
  components: {
    EditItemForm,
  },
  props: {
    con: null,
    editedItem: null,
  },
  data: () => ({
    rules: rules,
    fullCapacity: 0,
  }),
  methods: {
    close() {
      this.$emit("closed");
    },
    updatePartialCapacity(fullCapacity) {
      this.fullCapacity = +fullCapacity;
    },
  },
  watch: {
    editedItem(newValue) {
      this.fullCapacity = newValue ? newValue.fullCapacity : 0;
    },
  },
  mounted() {
    this.fullCapacity = this.editedItem.fullCapacity;
  },
};
</script>
